<div
  class="min-h-screen bg-black py-12 px-4 relative overflow-hidden flex items-center justify-center"
>
  <!-- Background splatter pattern - subtle dark texture -->
  <div
    class="absolute inset-0 opacity-[0.03] pointer-events-none"
    style="
      background-image: radial-gradient(
          circle at 20% 50%,
          rgba(255, 255, 255, 0.1) 1px,
          transparent 1px
        ),
        radial-gradient(
          circle at 80% 80%,
          rgba(255, 255, 255, 0.1) 1px,
          transparent 1px
        ),
        radial-gradient(
          circle at 40% 20%,
          rgba(255, 255, 255, 0.1) 1px,
          transparent 1px
        );
      background-size: 200px 200px, 300px 300px, 250px 250px;
    "
  ></div>

  <div class="w-full max-w-2xl mx-auto text-center relative z-10">
    <!-- ABC Logo -->
    <div class="mb-8 flex justify-center">
      <img
        [src]="logoPath"
        alt="ABC Talkies Logo"
        class="h-12 md:h-16 w-auto object-contain animate-fade-in"
        onerror="this.style.display='none'"
      />
    </div>

    <!-- Loading/Content Card -->
    <div
      class="bg-black1 rounded-2xl p-8 md:p-12 shadow-2xl border border-black3/50 backdrop-blur-sm"
    >
      <!-- Loading Spinner -->
      <div *ngIf="isLoading && !hasError" class="mb-6">
        <div class="inline-block relative w-16 h-16">
          <div
            class="absolute inset-0 rounded-full border-4 border-black3"
          ></div>
          <div
            class="absolute inset-0 rounded-full border-4 border-transparent border-t-green-primary animate-spin"
          ></div>
        </div>
      </div>

      <!-- Error Icon -->
      <div *ngIf="hasError" class="mb-6">
        <div
          class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red/20 border-2 border-red/50"
        >
          <svg
            class="w-8 h-8 text-red"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </div>
      </div>

      <!-- Success/Redirect Icon -->
      <div *ngIf="!isLoading && !hasError" class="mb-6">
        <div
          class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-primary/20 border-2 border-green-primary/50 animate-pulse"
        >
          <svg
            class="w-8 h-8 text-green-primary"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 7l5 5m0 0l-5 5m5-5H6"
            ></path>
          </svg>
        </div>
      </div>

      <!-- Message Content -->
      <div class="space-y-4">
        <h2
          *ngIf="!hasError"
          class="text-2xl md:text-3xl font-bold text-white mb-2"
        >
          <span *ngIf="isLoading">Loading...</span>
          <span *ngIf="!isLoading">Redirecting</span>
        </h2>
        <h2
          *ngIf="hasError"
          class="text-2xl md:text-3xl font-bold text-red mb-2"
        >
          Oops!
        </h2>

        <p
          *ngIf="message"
          class="text-lg md:text-xl text-white-primary leading-relaxed"
        >
          {{ message }}
        </p>
        <p
          *ngIf="!message && isLoading"
          class="text-lg md:text-xl text-white-primary leading-relaxed"
        >
          Please wait while we prepare your content...
        </p>
      </div>

      <!-- Dotted Loader -->
      <div
        *ngIf="!hasError && !isLoading"
        class="mt-8 flex justify-center items-center gap-2"
      >
        <div class="dot-loader-dot bg-green-primary"></div>
        <div class="dot-loader-dot bg-green-primary"></div>
        <div class="dot-loader-dot bg-green-primary"></div>
      </div>
    </div>

    <!-- Footer Text -->
    <p class="mt-6 text-sm text-gray3">
      Powered by
      <span class="text-green-primary font-semibold">ABC Talkies</span>
    </p>
  </div>
</div>
